import { useEffect, useRef, useState } from "react";
import bottles from "../../images/herobottles.png";
import "./CampaCola.css";

const CampaCola = () => {
  const [isPopupVisible, setPopupVisible] = useState(false);

  const togglePopup = () => {
    setPopupVisible(!isPopupVisible);
  };

  const heroRef = useRef(null);
  const [isDisplay, setIsDisplay] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsDisplay(true);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (heroRef.current) {
      observer.observe(heroRef.current);
    }

    const heroRefCurrentValue = heroRef.current;

    return () => {
      if (heroRefCurrentValue) {
        observer.unobserve(heroRefCurrentValue);
      }
    };
  }, []);

  return (
    <div>
      <div
        style={{
          //  minWidth: '100%',
          //  minHeight: '100%',
          height: "90vh",
          width: "100%",
          position: "relative",
          backgroundImage: `url("https://campabeveragesadmin.ril.com/uploads/hero_banner_d964ca96b2.png")`,
          backgroundSize: "cover",
          backgroundPosition: " 50% center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          maxHeight: "1500px",
        }}
      >
        <div
          className="data"
          style={{
            width: "100%",
            maxWidth: "666px",
            minHeight: "120px",
            backgroundPosition: "center",
            position: "absolute",
            transform: "translate(-50%, -110%)",
            left: "50%",
            zIndex: "1",
          }}
        >
          <img
            className="desktop-image"
            src={`${process.env.REACT_APP_BASENAME}/svgs/hero_header_text.svg`}
            alt="bottles"
          />
          <img
            className="mobile-image"
            src={`${process.env.REACT_APP_BASENAME}/svgs/hero_header_text_mob.svg`}
            alt="mobile bottles"
          />
        </div>
        {/* Button centered on the background */}
        <button
          className="watch-now-button"
          style={{
            position: "absolute",
            display: "flex",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -85%)",
            padding: "20px 18px",
            backgroundColor: "transparent",
            border: "1px solid #fff",
            cursor: "pointer",
            borderRadius: "10px",
            zIndex: 1,
            fontFamily: "LogikWide",
            fontSize: "18px",
            fontWeight: 700,
            overflow: "hidden",
            color: "#fff",
            gap: "8px",
          }}
          onClick={togglePopup}
          onMouseEnter={(e) =>
            ((e.target as HTMLButtonElement).style.backgroundColor = "purple")
          }
          onMouseLeave={(e) =>
            ((e.target as HTMLButtonElement).style.backgroundColor =
              "transparent")
          }
        >
          WATCH NOW
          <img
            src={`${process.env.REACT_APP_BASENAME}/svgs/play_icon.svg`}
            alt="play icon"
            style={{
              width: "24px",
              height: "24px",
            }}
          />
        </button>

        {isPopupVisible && (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              zIndex: 2,
              width: "70%",
              height: "70%",
              position: "absolute",
              transform: "translate(-50%, -60%)",
              top: "50%",
              left: "50%",
            }}
          >
            <img
              src="/cross.png"
              alt="Close"
              onClick={() => setPopupVisible(false)}
              style={{
                position: "absolute",
                top: "10px",
                right: "5px",
                width: "40px",
                height: "40px",
                cursor: "pointer",
                zIndex: 3,
                color: "transparent",
              }}
            />

            <iframe
              className="screensize"
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/iOBDoiTMLMI"
              title="Campa - Naye India Ka Apna Thanda! (50 secs)"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerPolicy="strict-origin-when-cross-origin"
              allowFullScreen
            ></iframe>
          </div>
        )}

        <div
          ref={heroRef}
          style={{
            position: "absolute",
            // animation: 'slideUp 0.7s ease-out forwards'
            animation: isDisplay ? "slideUp 0.7s ease-out forwards" : "none",
          }}
        >
          <img
            className="check"
            src={bottles}
            alt="bottles"
            style={{
              width: "100%",
              height: "100vh",
              objectFit: "cover",
              display: "block",
            }}
          />
        </div>
      </div>
      <style>{`
                  
                 
              `}</style>
    </div>
  );
};

export default CampaCola;
